// extracted by mini-css-extract-plugin
module.exports = {"content":"AppRoutes_content__2jBAW"};